import { HttpInterceptorFn, HttpErrorResponse, HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from "@features/auth/auth.service";
import { catchError, switchMap, filter, take, throwError, BehaviorSubject, Observable, finalize } from 'rxjs';

const refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const token = authService.getToken();

    const isPublicUrl = req.url.includes('/auth/login') || req.url.includes('/auth/refresh') || req.url.includes('/public/deca/');

    if (token && !isPublicUrl && authService.isTokenExpiringSoon()) {
        return handle401Error(req, next, authService);
    }

    let authReq = req;
    if (token && !isPublicUrl) {
        authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });
    }

    return next(authReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                if (isPublicUrl || req.url.includes('/auth/logout')) {
                    return throwError(() => error);
                }
                return handle401Error(authReq, next, authService);
            }
            return throwError(() => error);
        })
    );
};

function handle401Error(request: HttpRequest<any>, next: HttpHandlerFn, authService: AuthService) {
    if (!authService.isRefreshing) {
        authService.isRefreshing = true;
        refreshTokenSubject.next(null);

        return authService.refreshToken().pipe(
            switchMap((response) => {
                authService.isRefreshing = false;
                refreshTokenSubject.next(response.accessToken);
                return next(request.clone({
                    setHeaders: { Authorization: `Bearer ${response.accessToken}` }
                }));
            })
        );
    } else {
        return refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap((token) => {
                return next(request.clone({
                    setHeaders: { Authorization: `Bearer ${token}` }
                }));
            })
        );
    }
}
